mobileSize = 1000;

function placeHeaderBtns() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('#headerButtons').insertBefore('.header-top');
  } else {
    $('#headerButtons').insertAfter('.quick-links');
  }
}

function animateBookNow() {
  if ($('body').hasClass('saffireLargeSize')) {
    $('#bookNow')
      .addClass('animate__animated animate__slideInLeft')
      .css('opacity', '1');
  } else {
    $('#bookNow').css('opacity', '1')
  }
}


$(document).ready(function () {

  $('.cookie-banner-content p').html(`We use cookies to offer you a better browsing experience, analyze site traffic, personalize content and serve targeted advertisements. To learn more or change your cookie preferences, choose <em>Manage Cookie Preferences</em>. For further information on the use of cookies and information we collect, visit our <a href="https://www.asmglobal.com/p/other/privacy-policy" target="_blank">Privacy Policy</a>.`);


  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1000) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1001) {
    $('body').removeClass('saffireMobileSize');
  }

  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
  $('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Place Header Buttons
  placeHeaderBtns();

  // Animations
  animateBookNow();

  // Email Signup
  $('.email-signup-container .emailSignup .emailSubmitButton').text('Subscribe');
  $('.email-signup-container .emailSignup .emailInputField input')
    .attr('value', '')
    .attr('placeholder', 'Email email address');
});

$(window).load(function () {
  $('body').addClass('pageIsLoaded');
});

$(window).resize(function () {
  // Place Header Buttons
  placeHeaderBtns();

  // Animations
  animateBookNow();
});